import { type FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import Lookup from '@/components/UI/Lookup';
import type { FieldProps, SelectOption } from '../VerticalStepForm.model';

/**
 * Async paginated select field. Wraps the Lookup component with RHF Controller.
 * The form value holds the full selected option ({ label, value }) so the
 * label survives step collapse/reopen; VerticalStepForm flattens select fields
 * to their primitive value before invoking onSubmit.
 */
const SelectField: FC<FieldProps> = ({ name, label, showLabel, placeholder, loadOptions, rules, onValueChange }) => {
  const { control } = useFormContext();

  return (
    <div>
      {showLabel && (
        <label htmlFor={name} className="db mb1 f6 near-black basier-med">
          {label}
        </label>
      )}
      <Controller
        name={name}
        control={control}
        rules={{
          ...rules,
          validate: rules?.required
            ? (value) => (value?.value ? true : typeof rules.required === 'string' ? rules.required : 'Required')
            : undefined,
        }}
        render={({ field: { onChange, value } }) => (
          <Lookup
            name={name}
            inputId={name}
            loadOptions={loadOptions}
            handleSelect={(data: SelectOption | null) => {
              onChange(data ?? null);
              onValueChange?.();
            }}
            value={value ?? null}
            placeholder={placeholder ?? 'Search...'}
            cacheOptions={false}
          />
        )}
      />
    </div>
  );
};

export default SelectField;
